import * as themeColors from '../../../assets/scss/partials/_colors.scss?module';

/**
 * Resolves the card back/theme color based on color type and custom color selection.
 * @param {string} cardColorType - 'primary', 'secondary', or 'custom'
 * @param {string} cardCustomColor - hex color code if 'custom' is selected
 * @returns {string} - resolved CSS variable or hex color string
 */
export const resolveThemeColor = (cardColorType, cardCustomColor) => {
    switch (cardColorType) {
        case 'secondary':
            return 'var(--bs-secondary, #6c757d)';
        case 'custom':
            return cardCustomColor || `var(--bs-primary, ${themeColors.primary || '#029ed4'})`;
        default:
            return `var(--bs-primary, ${themeColors.primary || '#029ed4'})`;
    }
};

/**
 * Resolves the background color for buttons inside the win modal.
 * @param {string} btnColorType - 'primary', 'secondary', 'custom', 'yellow', or empty
 * @param {string} btnCustomColor - hex color code if 'custom' is selected
 * @returns {string|undefined} - resolved button background color
 */
export const resolveButtonColor = (btnColorType, btnCustomColor) => {
    switch (btnColorType) {
        case 'primary':
            return 'var(--bs-primary, #0067c7)';
        case 'secondary':
            return 'var(--bs-secondary, #65b32e)';
        case 'custom':
            return btnCustomColor || undefined;
        case 'yellow':
            return '#f5a623';
        default:
            return undefined;
    }
};

/**
 * Resolves the text color for the win modal's action button.
 * @param {string} textColorType - 'dark', 'white', 'custom', or empty
 * @param {string} textCustomColor - hex color code if 'custom' is selected
 * @param {string} defaultBtnTextColor - fallback color calculated from background brightness
 * @returns {string} - resolved button text color
 */
export const resolveButtonTextColor = (textColorType, textCustomColor, defaultBtnTextColor) => {
    switch (textColorType) {
        case 'dark':
            return 'var(--bs-dark, #212529)';
        case 'white':
            return '#ffffff';
        case 'custom':
            return textCustomColor || defaultBtnTextColor;
        default:
            return defaultBtnTextColor;
    }
};
